module.exports = __webpack_public_path__ + "img/live_logo.9361db02.png";